<template>
    <div class="card-pack">
        <div class="title">TOP统计信息
            <div class="condition-pack">
                <span v-for="n in nums"
                      :class="num===n &&'active'"
                      @click="init(n)"
                      class="item"
                      :key="n">{{n}}条</span>
            </div>
        </div>
        <div class="user-top">
            <div class="top-pack">
                <div class="title">用户账户余额
                    <a @click="$router.push('/accounts')"
                       class="more">
                        <i class="icon-arrow-under-o"></i>
                    </a>
                </div>
                <ul class="tbl-pack"
                    v-if="balanceData.length">
                    <li v-for="(item, k) in balanceData"
                        :key="`bla${k}`">
                        <span class="name-pack">
                            <span class="icon">
                                <i class="icon-medal"
                                   v-if="k<3"></i>
                                <span v-else
                                      class="num">{{k}}</span>
                            </span>
                            <span class="name"
                                  :title="item.accountName">{{item.accountName}}</span>
                        </span>
                        <b class="money">{{$money(item.balance,5)}}</b>
                    </li>
                </ul>
                <div v-else
                     class="no-data">暂无数据</div>
            </div>
            <div class="top-pack">
                <div class="title">用户到期资源</div>
                <ul class="tbl-pack"
                    v-if="resourceData.length">
                    <li v-for="(item, k) in resourceData"
                        :key="`bla${k}`">
                        <span class="name-pack">
                            <span class="icon">
                                <i class="icon-medal"
                                   v-if="k<3"></i>
                                <span v-else
                                      class="num">{{k}}</span>
                            </span>
                            <span class="name"
                                  :title="item.name">{{item.name}}</span>
                        </span>
                        <span>{{item.endTime}}</span>
                    </li>
                </ul>
                <div v-else
                     class="no-data">暂无数据</div>
            </div>
            <div class="top-pack">
                <div class="title">合同执行到期
                    <a @click="$router.push('/contracts')"
                       class="more">
                        <i class="icon-arrow-under-o"></i>
                    </a>
                </div>
                <ul class="tbl-pack"
                    v-if="contractData.length">
                    <li v-for="(item, k) in contractData"
                        :key="`bla${k}`">
                        <span class="name-pack">
                            <span class="icon">
                                <i class="icon-medal"
                                   v-if="k<3"></i>
                                <span v-else
                                      class="num">{{k}}</span>
                            </span>
                            <span class="name"
                                  :title="item.contractTitle">{{item.contractTitle}}</span>
                        </span>
                        <span class="time">{{item.endTime}}</span>
                        <b class="money">{{$money(item.amount,5)}}</b>
                    </li>
                </ul>
                <div v-else
                     class="no-data">暂无数据</div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/service/api'
export default {
    name: 'usertop',
    props: ['orgId'],
    data () {
        return {
            balanceData: [],
            resourceData: [],
            contractData: [],
            nums: [10, 50, 100],
            num: 10
        }
    },
    watch: {
        orgId (val) {
            this.init()
        }
    },
    mounted () {
        this.init()
    },
    methods: {
        init (val) {
            val && (this.num = val)
            this.axios.get(this.urlFormat(API.OPE_STATISTICS_TOP), {
                params: {
                    num: this.num,
                    orgId: this.orgId
                }
            }).then((res) => {
                this.balanceData = res.balance
                this.resourceData = res.resource
                this.contractData = res.contract
            })
        }
    }
}
</script>

<style lang="less" scoped>
.user-top {
    display: flex;
    margin: 10px -7.5px;
    .top-pack {
        width: 33.33333%;
        margin: 0 7.5px;
        border: 1px solid #e9e9e9;
        padding: 10px 0;
        .title {
            padding: 0 15px;
        }
        .more {
            min-width: 50px;
            text-align: right;
            .icon-arrow-under-o {
                display: inline-block;
                transform: rotate(-90deg);
                color: #999999;
                font-size: 10px;
                font-weight: 600;
            }
        }
    }
    .tbl-pack {
        margin: 5px 0;
        height: 300px;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 5px;
            height: 1px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: #cccccc;
        }
        li {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            line-height: 30px;
            padding: 0 15px;
            &:hover {
                background-color: #f5f6f7;
            }
            span {
                white-space: nowrap;
            }
            .name-pack {
                flex-grow: 1;
                width: 30%;
                text-overflow: ellipsis;
                overflow: hidden;
            }
            .time {
                display: inline-block;
                width: 100px;
                flex-shrink: 0;
            }
            .money {
                font-size: 12px;
                width: 30%;
            }
            .icon {
                display: inline-block;
                width: 20px;
                margin-right: 10px;
                i {
                    font-size: 16px;
                }
                .num {
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    text-align: center;
                    line-height: 16px;
                    background-color: #c1a687;
                    color: #fff;
                    font-size: 12px;
                    border-radius: 50%;
                }
            }
            .name {
                color: #808080;
            }
            b {
                font-size: 14px;
            }
            &:first-child {
                i {
                    color: #eaa434;
                }
            }
            &:nth-child(2) {
                i {
                    color: #9595af;
                }
            }
            &:nth-child(3) {
                i {
                    color: #b6858d;
                }
            }
        }
    }
    .no-data {
        text-align: center;
        color: #808080;
        padding: 30px 0;
    }
}
</style>
